import { businessIdSelector, sessionTokenSelector } from 'selectors/appSelector';
import { useAmplitudeSendEvent } from 'utils/analytics/AnalyticsContext';
import { useFeatureFlag } from '@tock/shared/utils/featureFlagContext';
import { useSelector } from 'react-redux';

/**
 * Returns a function that will send all appropriate messages about consumer-page conversion.
 * This function will be a no-op if the related CONSUMER_VENUE_PAGE_CONVERSION_INSTRUMENTATION flag is off.
 */
export function useConsumerConversionAnalytics() {
  const amplitudeSendEvent = useAmplitudeSendEvent();
  const businessId = useSelector(businessIdSelector);
  const sessionToken = useSelector(sessionTokenSelector);
  const isInstrumentationEnabled = useFeatureFlag('CONSUMER_VENUE_PAGE_CONVERSION_INSTRUMENTATION');

  if (!businessId || !sessionToken || !isInstrumentationEnabled) {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return (event: string) => {};
  }
  return (event: string) => {
    amplitudeSendEvent(event, {
      businessId,
      sessionToken,
    });
  };
}
